export const REQUEST_BOARD_CARD_LOCATION_SEPARATOR = ' · '
